import { Keyword, Number, Percentage, Token, Tuple } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Err, Result } from "@siteimprove/alfa-result";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { either, filter } = Parser;
const parseItem = filter(either(Number.parse, Percentage.parse), (size) => size.hasCalculation() || size.value >= 0, () => `Negative sizes are not allowed`);
const parseFill = Keyword.parse("fill");
/**
 * @internal
 */
export const parse = (input) => {
    let top;
    let right;
    let bottom;
    let left;
    let fill;
    while (true) {
        for ([input] of Token.parseWhitespace(input)) {
        }
        const result = parseItem(input);
        if (result.isOk()) {
            if (top === undefined) {
                [input, top] = result.get();
                continue;
            }
            if (right === undefined) {
                [input, right] = result.get();
                continue;
            }
            if (bottom === undefined) {
                [input, bottom] = result.get();
                continue;
            }
            if (left === undefined) {
                [input, left] = result.get();
                continue;
            }
        }
        else if (fill === undefined) {
            const result = parseFill(input);
            if (result.isOk()) {
                [input, fill] = result.get();
                continue;
            }
        }
        break;
    }
    if (top === undefined) {
        return Err.of(`Expected an image slice`);
    }
    right = right ?? top;
    bottom = bottom ?? top;
    left = left ?? right;
    return Result.of([
        input,
        fill
            ? Tuple.of(top, right, bottom, left, fill)
            : Tuple.of(top, right, bottom, left),
    ]);
};
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-image-slice}
 * @internal
 */
export default Longhand.of(Tuple.of(Percentage.of(1), Percentage.of(1), Percentage.of(1), Percentage.of(1)), parse, (value, style) => value.resolve(Resolver.length(style)));
//# sourceMappingURL=border-image-slice.js.map